<b>{{question.label}}</b>
<ul class="multiSelectList">
  @for (item of value; track item) {
    <li>{{item.ArmatureDesc}}</li>
  }
</ul>
